
// 获取多语插件 
export function getIntl(moduleId) {
	if (!moduleId){
		return;
	}

	return this.state.intl[moduleId]
}
